/***
 * Created on 2023/7/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../common/modal_dialog/modalDialog";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiDelete} from "../../service/api";
import {useTranslation} from "react-i18next";


function RemoveContactDialog(props) {
    const {meta, ..._props} = props;
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const removeContactMutation = useMutation({
        mutationFn: (friend_id) => apiDelete(`/ajax/friend/${friend_id}`),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['friend']
            })
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    })

    const onSubmit = async () => {
        console.log(meta);
        await removeContactMutation.mutateAsync(meta._id);
    }

    return (
        <ModalDialog {..._props} submitText={t('@Remove@')} submitAction={onSubmit}>
            <div className="dialog-content">
                <p style={{overflowWrap: "anywhere", wordBreak: "break-word"}}>
                    {t('@Do you really want to remove your friend from contact list?@')} {`"${meta?.nickname || meta?.email}"`}
                </p>
            </div>
        </ModalDialog>
    );
}

export default RemoveContactDialog;